import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Drawer from '@mui/material/Drawer';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import swal from "sweetalert2"; 
import Chapathi from '../../../../images/items/chapati.jpg';
import EditProductionCosting from '../../../modal/Production_Management/Manage_Production_Costing/EditProductionCosting';
import AddProductionCosting from '../../../modal/Production_Management/Manage_Production_Costing/AddProductionCosting';
import DatePicker, { DateObject } from "react-multi-date-picker";
import moment from 'moment';
import axios from 'axios';
import idly from '../../../../images/items/items.jpg';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const Manage_Production_Costing = () => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
     

    const onClose = () => {
        setFilterOpen(false);
    };
    const handleModalToggle = () => {
        setModalType("EditProductionCosting");
        setOpen(true);
    };

    const handleModalToggleAdd = () => {
        setModalType("AddProductionCosting");
        setOpen(true);
    };

  
    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    "pageLength": 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const [selectedOption, setSelectedOption] = useState(null); 
    const baseURL = process.env.REACT_APP_API_BASE_URL; 
    const tableRef = useRef(null); 
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(moment().startOf('isoWeek').toDate());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(moment().endOf('isoWeek').toDate());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const [productionWastage, setProductionWastage] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [TotalCount, setTotalCount] = useState('');

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];
    const [marginCapital, setMarginCapital] = React.useState(0);
    // const fetchWork = (isFiltered = true) => {
    //         const params = {};
    
    //             if (isFiltered && date_fil_selt_value !== "all") {
    //             switch (date_fil_selt_value) {
    //                 case "today":
    //                 case "date":
    //                     params.filter = "date"; 
    //                     params.date = moment(today_fil_value.toDate?.() || today_fil_value).format("YYYY-MM-DD");
    
    //                     break;
    
        
    //                 case "this_week":
    //                     params.filter = "week";
    //                     params.start_date = moment(week_stdt_fil_value.toDate?.() || week_stdt_fil_value).format("YYYY-MM-DD");
    //                     params.end_date = moment(week_eddt_fil_value.toDate?.() || week_eddt_fil_value).format("YYYY-MM-DD");
    //                     break;
    //                 case "this_month":
    //                     const month = moment(month_fil_value.toDate?.() || month_fil_value).format("YYYY-MM");
    //                     params.filter = "month";
    //                     params.start_month = month;
    //                     params.end_month = month;
    //                     break;
    //                 case "custom":
    //                     params.filter = "custom";
    //                     params.start_date = moment(custom_stdt_fil_value.toDate?.() || custom_stdt_fil_value).format("YYYY-MM-DD");
    //                     params.end_date = moment(custom_eddt_fil_value.toDate?.() || custom_eddt_fil_value).format("YYYY-MM-DD");
    //                     break;
    //                 default:
    //                     break;
    //             }
    //         }
    
    //         axios.get(`${baseURL}/production-costing-records`, { params })
    //             .then(res => {
    //                 if (res.data?.data) {
    //                     setProductionWastage(res.data.data);
    //                     if (res.data.margin_capital !== undefined) {
    //                         setMarginCapital(res.data.margin_capital);  // <-- Save margin_capital in state
    //                     }
    //                     setTotalCount(res.data.count);
    //                     setTotalPages(Math.ceil(res.data.count / perPage));
    
    //                     setTimeout(() => {
    //                         if ($.fn.dataTable.isDataTable(tableRef.current)) {
    //                             $(tableRef.current).DataTable().destroy();
    //                         }
    //                         $(tableRef.current).DataTable({
    //                             dom: 'Bfrtip',
    //                             buttons: [
    //                                 { extend: 'csv', className: 'buttons-csv d-none' },
    //                                 { extend: 'excel', className: 'buttons-excel d-none' },
    //                                 { extend: 'print', className: 'buttons-print d-none' }
    //                             ]
    //                         });
    //                     }, 100);
    //                 }
    //             })
    //             .catch(err => {
    //                 console.error("API Error: ", err);
    //             });
    //     };
    
    const [displayDateLabel, setDisplayDateLabel] = useState(moment().format("DD-MMM-YYYY"));

    const fetchWork = (isFiltered = true) => {
    const params = {};

    if (isFiltered && date_fil_selt_value !== "all") {
      switch (date_fil_selt_value) {
        case "today":
        case "date":
          params.filter = "date";
          const dateVal = moment(today_fil_value.toDate?.() || today_fil_value).format("YYYY-MM-DD");
          params.date = dateVal;
          setDisplayDateLabel(moment(dateVal).format("DD-MMM-YYYY"));
          break;

        case "this_week":
          params.filter = "week";
          const startWeek = moment(week_stdt_fil_value.toDate?.() || week_stdt_fil_value).format("YYYY-MM-DD");
          const endWeek = moment(week_eddt_fil_value.toDate?.() || week_eddt_fil_value).format("YYYY-MM-DD");
          params.start_date = startWeek;
          params.end_date = endWeek;
          setDisplayDateLabel(`${moment(startWeek).format("DD-MMM-YYYY")} to ${moment(endWeek).format("DD-MMM-YYYY")}`);
          break;

        case "this_month":
          const month = moment(month_fil_value.toDate?.() || month_fil_value).format("YYYY-MM");
          params.filter = "month";
          params.start_month = month;
          params.end_month = month;
          setDisplayDateLabel(moment(month).format("MMM YYYY"));
          break;

        case "custom":
          params.filter = "custom";
          const startCustom = moment(custom_stdt_fil_value.toDate?.() || custom_stdt_fil_value).format("YYYY-MM-DD");
          const endCustom = moment(custom_eddt_fil_value.toDate?.() || custom_eddt_fil_value).format("YYYY-MM-DD");
          params.start_date = startCustom;
          params.end_date = endCustom;
          setDisplayDateLabel(`${moment(startCustom).format("DD-MMM-YYYY")} to ${moment(endCustom).format("DD-MMM-YYYY")}`);
          break;

        default:
          setDisplayDateLabel(moment().format("DD-MMM-YYYY"));
          break;
      }
    } else {
      // Default to current date if no filter or 'all'
      setDisplayDateLabel(moment().format("DD-MMM-YYYY"));
    }

    axios.get(`${baseURL}/production-costing-records`, { params })
      .then(res => {
        const data = res.data?.data || [];
        setProductionWastage(data);

        if (res.data.margin_capital !== undefined) {
          setMarginCapital(res.data.margin_capital);
        }

        const count = res.data?.count || 0;
        setTotalCount(count);
        setTotalPages(Math.ceil(count / perPage));

        setTimeout(() => {
          if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
          }

          $(tableRef.current).DataTable({
            dom: 'Bfrtip',
            buttons: [
              { extend: 'csv', className: 'buttons-csv d-none' },
              { extend: 'excel', className: 'buttons-excel d-none' },
              { extend: 'print', className: 'buttons-print d-none' }
            ],
            language: {
              emptyTable: "No records found"
            }
          });
        }, 100);
      })
      .catch(err => {
        console.error("API Error: ", err);
        setProductionWastage([]);
        setTotalCount(0);
        setTotalPages(0);
      });
  };

//     const fetchWork = (isFiltered = true) => {
//     const params = {};

//     if (isFiltered && date_fil_selt_value !== "all") {
//         switch (date_fil_selt_value) {
//             case "today":
//             case "date":
//                 params.filter = "date";
//                 params.date = moment(today_fil_value.toDate?.() || today_fil_value).format("YYYY-MM-DD");
//                 break;
//             case "this_week":
//                 params.filter = "week";
//                 params.start_date = moment(week_stdt_fil_value.toDate?.() || week_stdt_fil_value).format("YYYY-MM-DD");
//                 params.end_date = moment(week_eddt_fil_value.toDate?.() || week_eddt_fil_value).format("YYYY-MM-DD");
//                 break;
//             case "this_month":
//                 const month = moment(month_fil_value.toDate?.() || month_fil_value).format("YYYY-MM");
//                 params.filter = "month";
//                 params.start_month = month;
//                 params.end_month = month;
//                 break;
//             case "custom":
//                 params.filter = "custom";
//                 params.start_date = moment(custom_stdt_fil_value.toDate?.() || custom_stdt_fil_value).format("YYYY-MM-DD");
//                 params.end_date = moment(custom_eddt_fil_value.toDate?.() || custom_eddt_fil_value).format("YYYY-MM-DD");
//                 break;
//             default:
//                 break;
//         }
//     }

//     axios.get(`${baseURL}/production-costing-records`, { params })
//         .then(res => {
//             const data = res.data?.data || [];
//             setProductionWastage(data);
            
//             if (res.data.margin_capital !== undefined) {
//                 setMarginCapital(res.data.margin_capital);
//             }

//             const count = res.data?.count || 0;
//             setTotalCount(count);
//             setTotalPages(Math.ceil(count / perPage));

//             setTimeout(() => {
//                 if ($.fn.dataTable.isDataTable(tableRef.current)) {
//                     $(tableRef.current).DataTable().destroy();
//                 }

//                 $(tableRef.current).DataTable({
//                     dom: 'Bfrtip',
//                     buttons: [
//                         { extend: 'csv', className: 'buttons-csv d-none' },
//                         { extend: 'excel', className: 'buttons-excel d-none' },
//                         { extend: 'print', className: 'buttons-print d-none' }
//                     ],
//                     // Optionally you can add this to show "No records" message inside DataTable itself
//                     language: {
//                         emptyTable: "No records found"
//                     }
//                 });
//             }, 100);
//         })
//         .catch(err => {
//             console.error("API Error: ", err);
//             // Clear data and reset pagination on error if you want
//             setProductionWastage([]);
//             setTotalCount(0);
//             setTotalPages(0);
//         });
// };


        const handleResetFilter = () => {
            setDateFilSeltValue("all");
            setTodayFilValue(new Date());
            setWeekSTDTFilValue(moment().startOf('isoWeek').toDate());
            setWeekEDDTFilValue(moment().endOf('isoWeek').toDate());
            setMonthFilValue(new Date());
            setCustomSTDTFilValue(new Date());
            setCustomEDDTFilValue(new Date());
            setPage(1);
            setFilterOpen(false);
            fetchWork(false);
        };
    
        const handleGoFilter = () => {
            setPage(1);
            setFilterOpen(false);
            const applyFilters = date_fil_selt_value !== "all";
            fetchWork(applyFilters);
        };
    
        const exportToCSV = () => {
            const csvRows = [];
            const headers = ['Item', 'Category / Sub Category', 'Product Category', 'Qty / Units', 'Assign Works', 'Status'];
            csvRows.push(headers.join(','));
    
            productionWastage.forEach(item => {
                const row = [
                    item.item_info?.name,
                    `${item.item_info?.category} / ${item.item_info?.sub_category}`,
                    item.product_info?.product_name || '-',
                    `${item.product_info?.quantity} ${item.product_info?.measurement_unit}`,
                    item.stagging_with_staff?.map(staff => staff.staff_name).join(', '),
                    'Work Not Started'
                ];
                csvRows.push(row.join(','));
            });
    
            const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, 'work_assignments.csv');
        };
    
        const exportToExcel = () => {
            const data = productionWastage.map(item => ({
                'Item': item.item_info?.name,
                'Category / Sub Category': `${item.item_info?.category} / ${item.item_info?.sub_category}`,
                'Product Category': item.product_info?.product_name || '-',
                'Qty / Units': `${item.product_info?.quantity} ${item.product_info?.measurement_unit}`,
                'Assign Works': item.stagging_with_staff?.map(staff => staff.staff_name).join(', '),
                'Status': 'Work Not Started'
            }));
    
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Assignments');
            XLSX.writeFile(workbook, 'work_assignments.xlsx');
        };
    
        
        const printTable = () => {
        const printContent = document.getElementById('work_assignment_table')?.outerHTML || '<p>No Data</p>';
        const newWin = window.open('', '_blank');
        newWin.document.write('<html><head><title>Work Assignment Print</title>');
        newWin.document.write('<style>table { width: 100%; border-collapse: collapse; } td, th { padding: 6px; border: 1px solid #ccc; }</style>');
        newWin.document.write('</head><body>');
        newWin.document.write('<h2>Work Assignment</h2>');
        newWin.document.write(printContent);
        newWin.document.write('</body></html>');
        newWin.document.close();
        newWin.print();
    };
    
    
        const handleExport = (type) => {
            switch (type) {
                case 'csv':
                    exportToCSV();
                    break;
                case 'excel':
                    exportToExcel();
                    break;
                case 'print':
                    printTable();
                    break;
                default:
                    break;
            }
        };
    
        useEffect(() => {
            fetchWork(false);
        }, []);
     
    const [selectedWastage, setSelectedWastage] = useState(null);
    
    const handleModalToggleCheckList = (wastage) => {
        setSelectedWastage(wastage);
        setModalType("Verify_Checklist");
        setOpen(true);
    };

        
    const [isVisible, setIsVisible] = useState({});
    
    const toggleDiv = (index) => {
      setIsVisible((prev) => ({
        ...prev,
        [index]: !prev[index],
      }));
    };

 

    
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Production Costing</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                    </ol>
                </div>
              <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                   
                </div>
                {open && modalType === "EditProductionCosting" && (
                    <EditProductionCosting show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "AddProductionCosting" && (
                    <AddProductionCosting show={open} onClose={() => setOpen(false)} />
                )}

            </div>
            <div className='row text-end'>
                <label className="fs-6 font-w600 mb-2 text-danger">{displayDateLabel}</label>
            </div>

            <div className="table-container">
                <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px'>Item</th>
                            <th className='min-w-80px'>Total Quantity / Units</th>
                            <th className='min-w-100px text-center'>Total Avg. Prod. Cost</th>
                            <th className='min-w-100px text-center'>Total Labour Cost</th>
                            <th className='min-w-100px text-end'>Total Cost / Profit</th>
                            {/* <th className='min-w-100px text-end'>Action</th> */}
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {productionWastage.length > 0 ? productionWastage.map((wastage, index) => (
                            <React.Fragment key={index}> 
                                <tr style={isVisible[index] ? { backgroundColor: 'rgb(255 240 240)' } : {}}>
                                    <td>
                                        <div className='d-flex align-items-center justify-content-start gap-2'>
                                            <Button variant="primary tp-btn-light border px-2 pt-1 pb-0 me-1"onClick={() => toggleDiv(index)}>
                                                {isVisible[index] ? (
                                                    <span><i className="fa-solid fa-angle-down fs-4"></i></span>
                                                ) : (
                                                    <span><i className="fa-solid fa-angle-right px-1 py-1 fs-4"></i></span>
                                                )}
                                            </Button>
                                            <LightGallery
                                                onInit={onInit}
                                                speed={500}
                                                plugins={[lgThumbnail, lgZoom]}
                                            >
                                                <div data-src={wastage.item?.image || idly} className='border rounded px-1 py-0'>
                                                    <img src={wastage.item?.image || idly} alt={wastage.item?.name} className='cursor-pointer w-45px h-45px' />
                                                </div>
                                            </LightGallery>
                                            <div>
                                                <label className='text-black font-w400 fs-7'>{wastage.item?.name}</label>
                                                <div className="d-block">
                                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Category</span></Tooltip>} >
                                                        <label className="fs-8 text-dark">{wastage.item?.category}</label>
                                                    </OverlayTrigger>
                                                    <span className="fs-8 text-dark"> / </span>
                                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Sub Category</span></Tooltip>} >
                                                        <label className="fs-8 text-dark">{wastage.item?.subcategory}</label>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <label className="text-black font-w400 fs-7">{wastage.total_quantity} {wastage.item?.unit}</label>
                                    </td>
                                    <td className='text-center'>
                                        <label className='text-danger font-w600 fs-6'>
                                            <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                            <span>{wastage.total_production_cost}</span>
                                        </label>
                                    </td>
                                    <td className='text-center'>
                                        <label className='text-danger font-w600 fs-6'>
                                            <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                            <span>{wastage.labour_cost}</span>
                                        </label>
                                    </td>
                                    <td className='text-end'>
                                        <label className='text-danger font-w600 fs-6'>
                                            <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                            <span>{wastage.total_cost}</span>
                                        </label>
                                        <div className='d-block'>
                                            <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Profit</span></Tooltip>} >
                                                <label className='text-primary font-w600 fs-7 rounded py-1 px-2 border-primary border'>
                                                    <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                                    <span>{wastage.profit}</span>
                                                </label>
                                            </OverlayTrigger>
                                        </div>
                                    </td>
                                
                                </tr>
                                {isVisible[index] && (
                                        <tr style={{ backgroundColor: '#ffffff' }}>
                                            <td colSpan={7}>
                                                <table className="table align-top table-striped table-hover fs-7 gy-1 gs-2">
                                                    <thead>
                                                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                            <th className='min-w-100px'>Order</th>
                                                            <th className='min-w-50px'>Qty (Units)</th>
                                                            <th className='min-w-80px'>Avg Prod Cost</th>
                                                            <th className='min-w-50px'>Labour Cost</th>
                                                            <th className='min-w-50px'>Margin Cost</th>
                                                            <th className='min-w-50px'>Total Cost</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                                        <tr>
                                                            <td>
                                                                <div className="d-flex flex-column align-items-start justify-content-start">
                                                                    <label className='text-black font-w500 fs-7'>Subscription</label>
                                                                    <label className='text-primary font-w600 fs-7'> {wastage.product_categories?.reduce(
                                                                        (total, cat) => total + (parseInt(cat.subscription_count) || 0),
                                                                        0
                                                                    )} Subscribers</label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>{wastage.total_quantity} {wastage.item?.unit}</label>
                                                            </td>
                                                            <td>
                                                                <Badge bg="danger" className='py-1 px-2 fs-8'>₹ {wastage.total_production_cost}</Badge>
                                                            </td>
                                                            <td>
                                                                <label className='text-white font-w400 fs-7 py-1 px-2 rounded' style={{backgroundColor: '#5f9ea0'}}>₹ {wastage.labour_cost}</label>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w600 fs-7'>₹ {wastage.total_margin_cost}</label>
                                                                <div className='d-block'>
                                                                    <labelc className='text-danger font-w500 fs-7'>({marginCapital}%)</labelc>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label className='text-white font-w500 fs-7 py-1 px-2 rounded' style={{backgroundColor: '#382383ff'}}>₹ {wastage.total_margin_with_cost}</label>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div className="d-flex flex-column align-items-start justify-content-start">
                                                                    <label className='text-black font-w500 fs-7'>Catering</label>
                                                                    <label className='text-primary font-w600 fs-7'>00 Order</label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>00 No's</label>
                                                            </td>
                                                            <td>
                                                                <Badge bg="danger" className='py-1 px-2 fs-8'>₹ 00</Badge>
                                                            </td>
                                                            <td>
                                                                <label className='text-white font-w400 fs-7 py-1 px-2 rounded' style={{backgroundColor: '#5f9ea0'}}>₹ 00</label>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w600 fs-7'>₹ 00</label>
                                                                <div className='d-block'>
                                                                    <labelc className='text-danger font-w500 fs-7'>(00%)</labelc>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label className='text-white font-w500 fs-7 py-1 px-2 rounded' style={{backgroundColor: '#382383ff'}}>₹ 00</label>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div className="d-flex flex-column align-items-start justify-content-start">
                                                                    <label className='text-black font-w500 fs-7'>Corporate Order</label>
                                                                    <label className='text-primary font-w600 fs-7'>00 Order</label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>00 No's</label>
                                                            </td>
                                                            <td>
                                                                <Badge bg="danger" className='py-1 px-2 fs-8'>₹ 00</Badge>
                                                            </td>
                                                            <td>
                                                                <label className='text-white font-w400 fs-7 py-1 px-2 rounded' style={{backgroundColor: '#5f9ea0'}}>₹ 00</label>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w600 fs-7'>₹ 00</label>
                                                                <div className='d-block'>
                                                                    <labelc className='text-danger font-w500 fs-7'>(00%)</labelc>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label className='text-white font-w500 fs-7 py-1 px-2 rounded' style={{backgroundColor: '#382383ff'}}>₹ 00</label>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr> 
                                )}
                                 </React.Fragment>
                                        )) : (
                                            <tr><td colSpan="5" className="text-center text-muted py-4">No Data Found</td></tr>
                                        )} 
                    </tbody>
                </table>
            </div >

                <Drawer
                           anchor="right"
                           open={filterOpen}
                           onClose={() => setFilterOpen(false)}
                           disableEscapeKeyDown
                           BackdropProps={{
                               onClick: (e) => e.stopPropagation(),
                           }}
                           sx={{
                               width: 400,
                               flexShrink: 0,
                               '& .MuiDrawer-paper': {
                                   width: 400,
                                   boxSizing: 'border-box',
                               },
                               '@media (max-width: 375px)': {
                                   '& .MuiDrawer-paper': {
                                       width: 320,
                                   },
                               },
                               '@media (max-width: 320px)': {
                                   '& .MuiDrawer-paper': {
                                       width: 280,
                                   },
                               },
                           }}
                       >
                           <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                               <h5 className='fs-4' style={{ color: '#ea1d25' }}>Manage Work Quality Analysis Filter</h5>
                               <div>
                                   <Button variant="" type="button" size='sm' onClick={() => setFilterOpen(false)}>
                                       <span className='fs-2'>×</span>
                                   </Button>
                               </div>
                           </div>
           
                           <div className='card border-0'>
                               <div className='card-body py-0'>
                                   <div className='row mb-2 py-2'>
                                       <div className="col-lg-12 mb-2">
                                           <label className="text-black font-w500 fs-7">Date</label>
                                           <Select
                                               value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                               onChange={(selectedOption) => {
                                                   const selectedValue = selectedOption.value;
                                                   setDateFilSeltValue(selectedValue);
           
                                                   if (selectedValue === "this_week") {
                                                       setWeekSTDTFilValue(moment().startOf('isoWeek').toDate());
                                                       setWeekEDDTFilValue(moment().endOf('isoWeek').toDate());
                                                   }
           
                                                   if (selectedValue === "today") {
                                                       setTodayFilValue(new Date());
                                                   }
           
                                                   if (selectedValue === "this_month") {
                                                       setMonthFilValue(new Date());
                                                   }
           
                                                   if (selectedValue === "custom") {
                                                       const now = new Date();
                                                       setCustomSTDTFilValue(now);
                                                       setCustomEDDTFilValue(now);
                                                   }
                                               }}
                                               options={date_fil_options}
                                               menuPlacement="top"
                                           />
                                       </div>
               
                                       {["today", "date"].includes(date_fil_selt_value) && (
                                       <div className="col-lg-12 mb-2">
                                           <label className="text-black font-w500 fs-7">Date</label>
                                           <div className='datepicker-wrapper d-flex'>
                                               <div className='input-group-text bg-transparent border-0 px-0'>
                                                   <i className='fa-solid fa-calendar-days fs-4'></i>
                                               </div>
                                               <DatePicker
                                                   value={today_fil_value}
                                                   onChange={setTodayFilValue}
                                                   format="DD-MM-YYYY"
                                               />
                                           </div>
                                       </div>
                                   )}
           
           
                                       {date_fil_selt_value === "this_week" && (
                                           <>
                                               <div className="col-lg-6 mb-2">
                                                   <label className="text-black font-w500 fs-7">Start Date</label>
                                                   <div className='datepicker-wrapper d-flex'>
                                                       <div className='input-group-text bg-transparent border-0 px-0'>
                                                           <i className='fa-solid fa-calendar-days fs-4'></i>
                                                       </div>
                                                       <DatePicker
                                                           value={week_stdt_fil_value}
                                                           onChange={setWeekSTDTFilValue}
                                                           format="DD-MM-YYYY"
                                                       />
                                                   </div>
                                               </div>
                                               <div className="col-lg-6 mb-2">
                                                   <label className="text-black font-w500 fs-7">End Date</label>
                                                   <div className='datepicker-wrapper d-flex'>
                                                       <div className='input-group-text bg-transparent border-0 px-0'>
                                                           <i className='fa-solid fa-calendar-days fs-4'></i>
                                                       </div>
                                                       <DatePicker
                                                           value={week_eddt_fil_value}
                                                           onChange={setWeekEDDTFilValue}
                                                           format="DD-MM-YYYY"
                                                           calendarPosition="top-end"
                                                       />
                                                   </div>
                                               </div>
                                           </>
                                       )}
           
                                       {date_fil_selt_value === "this_month" && (
                                           <div className="col-lg-12 mb-2">
                                               <label className="text-black font-w500 fs-7">This Month</label>
                                               <div className='datepicker-wrapper d-flex'>
                                                   <div className='input-group-text bg-transparent border-0 px-0'>
                                                       <i className='fa-solid fa-calendar-days fs-4'></i>
                                                   </div>
                                                   <DatePicker
                                                       value={month_fil_value}
                                                       onChange={setMonthFilValue}
                                                       format="MMM-YYYY"
                                                       calendarPosition="top"
                                                       mode="single"
                                                       onlyMonthPicker
                                                   />
                                               </div>
                                           </div>
                                       )}
           
                                       {date_fil_selt_value === "custom" && (
                                           <>
                                               <div className="col-lg-6 mb-2">
                                                   <label className="text-black font-w500 fs-7">Start Date</label>
                                                   <div className='datepicker-wrapper d-flex'>
                                                       <div className='input-group-text bg-transparent border-0 px-0'>
                                                           <i className='fa-solid fa-calendar-days fs-4'></i>
                                                       </div>
                                                       <DatePicker
                                                           value={custom_stdt_fil_value}
                                                           onChange={setCustomSTDTFilValue}
                                                           format="DD-MM-YYYY"
                                                       />
                                                   </div>
                                               </div>
                                               <div className="col-lg-6 mb-2">
                                                   <label className="text-black font-w500 fs-7">End Date</label>
                                                   <div className='datepicker-wrapper d-flex'>
                                                       <div className='input-group-text bg-transparent border-0 px-0'>
                                                           <i className='fa-solid fa-calendar-days fs-4'></i>
                                                       </div>
                                                       <DatePicker
                                                           value={custom_eddt_fil_value}
                                                           onChange={setCustomEDDTFilValue}
                                                           format="DD-MM-YYYY"
                                                           calendarPosition="top-end"
                                                       />
                                                   </div>
                                               </div>
                                           </>
                                       )}
                                   </div>
                               </div>
           
                               <div className="d-flex align-items-center justify-content-center gap-1 pb-3">
                                   <Button className="me-2 btn-sm" variant="secondary" onClick={handleResetFilter}>
                                       <span className='font-w400'>Reset</span>
                                   </Button>
                                   <Button className="me-2 btn-sm" variant="primary" onClick={handleGoFilter}>
                                       <span className='font-w400'>Go</span>
                                   </Button>
                               </div>
                           </div>
                </Drawer>
        </>
    )


}
export default Manage_Production_Costing;